import { render } from "./AITrainer.vue?vue&type=template&id=e54d260c&scoped=true&ts=true"
import script from "./AITrainer.vue?vue&type=script&lang=ts"
export * from "./AITrainer.vue?vue&type=script&lang=ts"

import "./AITrainer.vue?vue&type=style&index=0&id=e54d260c&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54d260c"]])

export default __exports__